import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { Phone, Mail, MapPin, Star } from 'lucide-react'

const Instagram = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    {...props}
  >
    <rect width='20' height='20' x='2' y='2' rx='5' ry='5' />
    <path d='M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z' />
    <line x1='17.5' x2='17.51' y1='6.5' y2='6.5' />
  </svg>
)
const Facebook = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    {...props}
  >
    <path d='M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z' />
  </svg>
)
const Linkedin = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    {...props}
  >
    <path d='M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z' />
    <rect width='4' height='12' x='2' y='9' />
    <circle cx='4' cy='4' r='2' />
  </svg>
)
const Youtube = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    {...props}
  >
    <path d='M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17' />
    <path d='m10 15 5-3-5-3z' />
  </svg>
)

const SERVICE_LINKS = [
  { label: 'Branding & Id. Visual', to: '/servicos/branding' },
  { label: 'Mídias Sociais', to: '/servicos/midias-sociais' },
  { label: 'Tráfego Pago', to: '/servicos/trafego-pago' },
  { label: 'Sites & E-commerces', to: '/servicos/tech' },
  { label: 'Produção Audiovisual', to: '/servicos/producao-audiovisual' },
  { label: 'SEO Estratégico', to: '/servicos/seo' },
]

const COMPANY_LINKS = [
  { label: 'Quem Somos', to: '/sobre' },
  { label: 'Serviços', to: '/servicos' },
  { label: 'Nosso Método', to: '/metodo' },
  { label: 'Blog', to: '/blog' },
]

const SOCIAL_LINKS = [
  { icon: Instagram, href: 'https://www.instagram.com/agenciadorac/', label: 'Instagram' },
  { icon: Facebook, href: 'https://www.facebook.com/agenciadorac/?locale=pt_BR', label: 'Facebook' },
  { icon: Linkedin, href: 'https://www.linkedin.com/company/agenciadorac/', label: 'LinkedIn' },
  { icon: Youtube, href: 'https://www.youtube.com/@agenciadorac', label: 'YouTube' },
]

function RisingWordmark({ word }) {
  const ref = useRef(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const node = ref.current
    if (!node) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true)
          observer.disconnect()
        }
      },
      { threshold: 0.2 },
    )

    observer.observe(node)
    return () => observer.disconnect()
  }, [])

  return (
    <h2
      ref={ref}
      className='w-full text-center font-display font-black uppercase tracking-tighter text-white'
      style={{ fontSize: 'min(28vw, 340px)', lineHeight: 0.8, margin: '0 -0.02em', whiteSpace: 'nowrap' }}
    >
      {word.split('').map((letter, index) => (
        <span
          key={`${letter}-${index}`}
          className='inline-block transition-all duration-700 ease-out'
          style={{
            transitionDelay: `${index * 90}ms`,
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(0.5em)',
          }}
        >
          {letter}
        </span>
      ))}
    </h2>
  )
}

function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer id='contato' className='dorac-grid-bg-dark text-white'>
      <div className='container mx-auto px-4 py-24'>
        <div className='grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4'>
          <div className='lg:col-span-1'>
            <Link to='/' className='mb-4 inline-block'>
              <span className='font-display text-3xl font-black uppercase tracking-tight'>Dorac</span>
            </Link>
            <p className='mb-6 text-sm leading-relaxed text-white/60'>
              A inquietude que inova e transforma conexões. Marketing Humanizado com Ciência do Comportamento e Consumo.
            </p>
            <div className='flex gap-3'>
              {SOCIAL_LINKS.map(({ icon: Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target='_blank'
                  rel='noopener noreferrer'
                  aria-label={label}
                  className='flex h-14 w-14 items-center justify-center rounded-lg bg-white/10 transition-all duration-200 hover:bg-white/20'
                >
                  <Icon className='h-7 w-7' strokeWidth={1.5} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className='mb-4 text-sm font-bold uppercase tracking-widest text-white/40'>Serviços</h4>
            <ul className='space-y-2'>
              {SERVICE_LINKS.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className='text-sm text-white/60 transition-colors hover:text-white'>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className='mb-4 text-sm font-bold uppercase tracking-widest text-white/40'>Empresa</h4>
            <ul className='space-y-2'>
              {COMPANY_LINKS.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className='text-sm text-white/60 transition-colors hover:text-white'>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className='mb-4 text-sm font-bold uppercase tracking-widest text-white/40'>Contato</h4>
            <ul className='space-y-3'>
              <li>
                <a
                  href='https://api.whatsapp.com/send?phone=554396659096'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='flex items-center gap-2 text-sm text-white/60 transition-colors hover:text-white'
                >
                  <Phone className='h-4 w-4 flex-shrink-0 text-dorac-purple-dark' style={{ color: '#FFE98C' }} />
                  (43) 9665-9096
                </a>
              </li>
              <li>
                <a
                  href='mailto:comercial@dorac.com.br'
                  className='flex items-center gap-2 text-sm text-white/60 transition-colors hover:text-white'
                >
                  <Mail className='h-4 w-4 flex-shrink-0' style={{ color: '#FFE98C' }} />
                  comercial@dorac.com.br
                </a>
              </li>
              <li>
                <a
                  href='https://maps.app.goo.gl/36HkWbnMJChJYtUy7'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='flex items-start gap-2 text-sm text-white/60 transition-colors hover:text-white'
                >
                  <MapPin className='mt-0.5 h-4 w-4 flex-shrink-0' style={{ color: '#FFE98C' }} />
                  Rua Professora Diva Proença, 1855 - Sala 03 - Centro, Ivaiporã - PR, 86870-174
                </a>
              </li>
            </ul>
            <div className='mt-6'>
              <Link to='/contato' className='btn-dorac w-full justify-center text-sm'>
                Solicitar diagnóstico
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className='pointer-events-none w-full select-none overflow-hidden leading-none'>
        <RisingWordmark word='DORAC' />
      </div>

      <div className='border-t border-white/10'>
        <div className='container mx-auto flex flex-col items-center justify-between gap-2 px-4 py-4 text-center sm:flex-row sm:text-left'>
          <p className='text-[11px] text-white/40 sm:text-xs'>
            © {currentYear} Dorac Agência. Todos os direitos reservados.
          </p>
          <div className='flex flex-wrap items-center justify-center gap-x-3 gap-y-1 sm:gap-x-4'>
            <Link
              to='/politica-de-privacidade'
              className='text-[11px] text-white/40 transition-colors hover:text-white/70 sm:text-xs'
            >
              Política de Privacidade
            </Link>
            <Link
              to='/termos-de-uso'
              className='text-[11px] text-white/40 transition-colors hover:text-white/70 sm:text-xs'
            >
              Termos de Uso
            </Link>
            <a
              href='https://www.linkedin.com/company/agenciadorac/'
              target='_blank'
              rel='noopener noreferrer'
              className='text-[11px] text-white/40 transition-colors hover:text-white/70 sm:text-xs'
            >
              Trabalhe Conosco
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
